/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import React from "react";
import SafeLink from "components/commons/SafeLink";
import PropTypes from "prop-types";
import {
  Heading,
  PrimaryText,
  SecondaryText
} from "components/Text";
import Slider from "react-slick";
import styled from "styled-components";
import {colors} from "nxtconstants";
import {ContentTypes} from "helpers";

const settings = {
  infinite: true,
  dots: true,
  speed: 500,
  lazyLoad: true,
  slidesToShow: 2,
  slidesToScroll: 2,
  // autoplay: true,
  autoplaySpeed: 3000,
  swipeToSlide: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    }
  ]
};

const propTypes = {
  content: PropTypes.array.isRequired
};

const defaultProps = {
  content: []
};

const Recommended = ({content}) => {
  const data = [];
  content.map((datum) => {
    const contentTagLink = (datum.categories && datum.categories.length) ?
      (`/${datum.contentType}/${datum.categories[0]}`)
      : `/${datum.contentType}`;

    data.push((
      <RecommendedContent key={datum.id}>
        <div className="recommend-img__container">
          <img
            alt="recommend image"
            className="recommend-img"
            src={datum.imageUrl}
          />
        </div>
        <div className="recommend-title">
          <SafeLink
            className="recommend-title__tag--link"
            href={contentTagLink}
          >
            <PrimaryText
              additionalStyles="text-transform: uppercase; font-weight: 700"
              className="recommend-title__tag"
              color={colors.razzmatazz}
            >
              {datum.contentType}
            </PrimaryText>
          </SafeLink>
          <SafeLink
            className="recommend-title__link"
            href={(`/${ContentTypes[datum.contentType]}/${datum.slug}-${datum.id}`)}
            rel="noopener noreferrer"
            target="_blank"
          >
            <SecondaryText
              additionalStyles="line-height: 3rem; margin-top: 1rem" className="recommend-title__heading"
              color={colors.luckyPoint}
              fontSize="2.3rem"
            >
              {datum.title || ""}
            </SecondaryText>
          </SafeLink>
        </div>
        <div className="recommend-footer">
          <PrimaryText
            additionalStyles="text-transform: capitalize"
            className="recommend-footer__text"
            color={colors.gray}
          >
              By {datum.metaAuthor || "Team Wealthy"}
          </PrimaryText>
          <hr className="recommend-divider" />
          <div
            style={{
              display: "flex",
              alignItems: "center"
            }}
          >
            <PrimaryText
              className="recommend-footer__text"
              color={colors.gray}
            >
              {datum.readTime || "0"} mins read
            </PrimaryText>
          </div>
        </div>
      </RecommendedContent>
    ));
  });
  return (
    <>
      <SecondaryText
        className="recommend-heading"
        fontSize="1.8rem"
      >
        RECOMMENDED
      </SecondaryText>
      <Title> Timeless Reads</Title>

      <Slider {...settings}>
        {data}
      </Slider>
    </>
  );
};

const RecommendedContent = styled.div`
  width: 90% !important;
  max-width: 550px;
  min-width: 290px;
  height: 52rem;
  background: ${colors.white};
  margin: 2rem 2rem 2rem 0.8rem;
  display: grid !important;
  grid-template-rows: 30rem 12rem 10rem;
  box-shadow: 0 2px 6px 2px rgba(166, 166, 166, 0.2);
  overflow:hidden;

  @media (max-width: 48em) {
    height: 40rem;
    grid-template-rows: 24rem 8rem 8rem;
    margin: 0.1rem auto;
    box-shadow: 0 2px 2px 0px rgba(166, 166, 166, 0.2);
  }

  .recommend-img__container {
    width: 100%;
    height: 100%;
    min-width: 300px;
  }

  .recommend-img {
    object-fit: cover;
    width: 100%;
    height: 100%;
    max-width: 100%;
  }

  .recommend-title,
  .recommend-footer {
    padding: 2rem;
  }

  .recommend-footer {
    align-self: end;
  }

  .recommend-title__link:hover {
    text-decoration: underline;
  }

  .recommend-divider {
    border-color: ${colors.gray};
    border-bottom: none;
    opacity: 0.2;
    margin: 5px 0;
  }
`;
const Title = styled.h2 `
  font-family: Avenir-Heavy;
  font-weight: initial;
  color: #263276;
  font-size: 3.2rem;
  line-height: calc(3.2rem * 1.5);
  margin: 1rem 0 2rem 0;
`;




Recommended.propTypes = propTypes;
Recommended.defaultProps = defaultProps;

export default Recommended;

